import React from "react";
import * as FaIcons from "react-icons/fa";

const R15ParentCustodyInformation = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    firstName,
    custodyIssueExists,
    custodyIssueNotes,
    legalRestrictionsForAnyParent,
    legalRestrictionsNotes,
  } = formData;
  return (
    <>
      {/* Parent Custody Information */}
      <div className="sub-form">
        <h3>Parent Custody Information</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Do any Custody Issues Exists for{" "}
              {firstName === "" ? "the Student" : firstName}?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(custodyIssueExists["yes"] || custodyIssueExists["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={custodyIssueExists["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="custodyIssueExists"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={custodyIssueExists["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="custodyIssueExists"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {custodyIssueExists["yes"] && (
          <div className="sum-item">
            <h4>Custody Issue Notes </h4>
            <textarea
              name="custodyIssueNotes"
              cols="30"
              rows="4"
              onChange={(e) => {
                onFormDataChange(e);
              }}
              value={custodyIssueNotes}
            ></textarea>
          </div>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Are there any Legal Restrictions for{" "}
              {firstName === "" ? "the Student" : firstName}'s parents
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  legalRestrictionsForAnyParent["yes"] ||
                  legalRestrictionsForAnyParent["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={legalRestrictionsForAnyParent["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="legalRestrictionsForAnyParent"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={legalRestrictionsForAnyParent["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="legalRestrictionsForAnyParent"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {legalRestrictionsForAnyParent["yes"] && (
          <div className="sum-item">
            <h4>Legal Restriction Notes </h4>
            <textarea
              name="legalRestrictionsNotes"
              cols="30"
              rows="4"
              onChange={(e) => {
                onFormDataChange(e);
              }}
              value={legalRestrictionsNotes}
            ></textarea>
          </div>
        )}
      </div>
    </>
  );
};

export default R15ParentCustodyInformation;
